<script setup lang="ts">
import { ref, onMounted } from 'vue';

const props = defineProps<{
  /** True when a previously entered password was rejected. */
  incorrect: boolean;
}>();

const emit = defineEmits<{
  (e: 'submit', password: string): void;
  (e: 'cancel'): void;
}>();

const password = ref('');
const inputRef = ref<HTMLInputElement | null>(null);

onMounted(() => inputRef.value?.focus());

const submit = () => {
  if (!password.value) return;
  emit('submit', password.value);
};
</script>

<template>
  <div class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4" @keydown.esc="emit('cancel')">
    <form
      class="w-full max-w-sm rounded-xl bg-white dark:bg-gray-800 p-6 shadow-xl"
      @submit.prevent="submit"
    >
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">Password required</h3>
      <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">
        This PDF is protected. Enter its password to open it.
      </p>
      <input
        ref="inputRef"
        v-model="password"
        type="password"
        autocomplete="off"
        class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
        placeholder="PDF password"
      />
      <p v-if="props.incorrect" class="mt-2 text-sm text-red-600">Incorrect password. Please try again.</p>
      <div class="mt-5 flex justify-end gap-2">
        <button
          type="button"
          class="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
          @click="emit('cancel')"
        >
          Cancel
        </button>
        <button
          type="submit"
          :disabled="!password"
          class="px-4 py-2 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 rounded-lg disabled:opacity-50"
        >
          Open
        </button>
      </div>
    </form>
  </div>
</template>
